import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import campaignReducer from './slices/campaignSlice';
import dashboardReducer from './slices/dashboardSlice';
import notificationReducer from './slices/notificationSlice';
import adminReducer from './slices/adminSlice';
import authReducer from './slices/authSlice';
import campaignTemplateReducer from './slices/campaignTemplateSlice';
import paymentReducer from './slices/paymentSlice';
import { setStore } from './api/axiosManager';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    campaigns: campaignReducer,
    dashboard: dashboardReducer,
    notifications: notificationReducer,
    admin: adminReducer,
    campaignTemplates: campaignTemplateReducer,
    payment: paymentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Date ve diğer non-serializable değerler için
    }),
  devTools: process.env.NODE_ENV !== 'production', // Production'da DevTools kapalı
});

// Axios interceptor'a store'u set et
setStore(store);

export default store;

